import React from 'react';

var getDimensions = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
});

export default class FullScreen extends React.Component {
  props: {
    children: React.Element,
  };

  constructor(props) {
    super(props);
    this.state = getDimensions();
  }

  handleResize = () => {
    this.setState(getDimensions());
  }

  componentDidMount() {
    document.body.style.overflowY = 'hidden';
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    if (typeof document !== 'undefined') {
      document.body.style.overflowY = 'scroll';
    }
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    return React.cloneElement(React.Children.only(this.props.children), {
      width: this.state.width,
      height: this.state.height,
    });
  }
}



// WEBPACK FOOTER //
// ../src/client/components/layout/FullScreen.js